import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { ToolbarButton } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { rotateRight as rotateRightIcon } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import { useImageEditingContext } from './context';
export default function RotationButton() {
  const {
    isInProgress,
    rotateClockwise
  } = useImageEditingContext();
  return createElement(ToolbarButton, {
    icon: rotateRightIcon,
    label: __('Rotate'),
    onClick: rotateClockwise,
    disabled: isInProgress
  });
}
//# sourceMappingURL=rotation-button.js.map